import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, take } from 'rxjs/operators';
import { AuthState } from '../../../store/auth/auth.state';

export const AuthGuard: CanActivateFn = (_route, state): ReturnType<CanActivateFn> => {
  const router = inject(Router);
  const store = inject(Store);

  const redirectUrl = state.url;
  const isAuthRoute = state.url.startsWith('/auth');

  return store.select(AuthState.loaded).pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => {
      const isAuthenticated = store.selectSnapshot(AuthState.isAuthenticated);
      if (isAuthenticated && isAuthRoute) return router.createUrlTree(['/home']);
      if (!isAuthenticated && !isAuthRoute) return router.createUrlTree(['/auth'], { queryParams: { redirectUrl } });
      return true;
    }),
  );
};
